import {HttpClient} from "../../service/httpClient/HttpClient";


export class GeneralService {

    constructor(token, loading, snackbar) {
        this.token = token;
        this.loading = loading;
        this.snackbar = snackbar;

        this.httpClient = new HttpClient()
    }

    getAvailableCashList(page, size) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `fund-presentation/total-owners/funds`,
                this.httpClient.prepareUserAccessHeader(this.token),
                {
                    page,
                    size
                }
            ).then(resolve).catch(reject)
        })
    }
}